<div class="properties">
  <span *ngIf="type" class="property-value">
    {{getPropertyValuebyType(properties, key, type, serviceItemList, purposeOfTravelItemList, causes, diagnoses, customerProfiles)}}
  </span>
  <span *ngIf="!type && taskWebPropertiesService.isStringProperty(properties, key) || taskWebPropertiesService.isTypeProperty(properties, key)" class="property-value">
    {{getPropertyValue(properties, key, serviceItemList, purposeOfTravelItemList, causes, diagnoses, customerProfiles)}}
  </span>
</div>
